import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { AuthGate } from "./AuthGate.js";
import "./sandbox.css";

const el = document.getElementById("root");
if (el === null) {
  throw new Error("Falta #root en index.html");
}

createRoot(el).render(
  <StrictMode>
    <AuthGate>
      <App />
    </AuthGate>
  </StrictMode>,
);
